export const methods = {
  async imprimirComprovante() {
    setTimeout(window.print, 500)
  },
}
